export default {
  light: {
    PRIMARY_COLOR: '#000000',
  
  },
  dark: {
    PRIMARY_COLOR: '#000000',
  },
}
